import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useI18n } from "../../i18n";

const values = [
  { value: 2016, suffix: "" },
  { value: 5, suffix: "" },
  { value: 6, suffix: "" },
  { value: 30, suffix: "+" },
];

const CountUp = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1400;
    const tick = (ts) => {
      const p = Math.min((ts - start) / dur, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return <span ref={ref}>{n}{suffix}</span>;
};

export const Stats = () => {
  const { t } = useI18n();
  const labels = t("stats.labels");
  return (
    <section className="relative py-24 lg:py-32 border-t border-white/10" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16"
        >
          <h2 className="font-heading font-bold tracking-tighter text-3xl lg:text-4xl max-w-md">
            {t("stats.heading")} <span className="text-gold">{t("stats.headingGold")}</span>
          </h2>
          <p className="text-[#8A9DB1] max-w-sm text-base md:text-lg">{t("stats.sub")}</p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {values.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="p-8 lg:p-12"
              style={{ background: "#0F2027" }}
              data-testid={`stat-item-${i}`}
            >
              <div className="font-heading font-bold text-5xl lg:text-6xl text-gold tracking-tighter">
                <CountUp value={s.value} suffix={s.suffix} />
              </div>
              <div className="text-[#8A9DB1] text-sm mt-4 uppercase tracking-[0.15em] font-heading">{labels[i]}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
